var _desc, _defs, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInstagramIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "\n\t\t\tCreated with Pixso.\n\t")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    gradientTransform: "translate(8.5 34.4646) rotate(-90) scale(31.7144 29.4969)",
    cx: 0,
    cy: 0,
    r: 1,
    id: "paint_radial_295_4_0",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDD55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFDD55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FF543E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C837AB"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    gradientTransform: "translate(-5.36015 2.30513) rotate(78.681) scale(14.1765 58.436)",
    cx: 0,
    cy: 0,
    r: 1,
    id: "paint_radial_295_5_0",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3771C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.128,
    stopColor: "#3771C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6600FF",
    stopOpacity: 0
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.5 0L24.5 0C28.64 0 32 3.35 32 7.5L32 24.5C32 28.64 28.64 32 24.5 32L7.5 32C3.35 32 0 28.64 0 24.5L0 7.5C0 3.35 3.35 0 7.5 0Z",
    fill: "url(#paint_radial_295_4_0)",
    fillOpacity: 1,
    fillRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.5 0L24.5 0C28.64 0 32 3.35 32 7.5L32 24.5C32 28.64 28.64 32 24.5 32L7.5 32C3.35 32 0 28.64 0 24.5L0 7.5C0 3.35 3.35 0 7.5 0Z",
    fill: "url(#paint_radial_295_5_0)",
    fillOpacity: 1,
    fillRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16 3.5C12.6 3.5 12.18 3.51 10.84 3.57C9.51 3.63 8.6 3.84 7.81 4.15C6.99 4.47 6.29 4.9 5.59 5.59C4.9 6.29 4.47 6.98 4.15 7.81C3.84 8.6 3.63 9.51 3.57 10.84C3.51 12.17 3.5 12.6 3.5 16C3.5 19.39 3.51 19.81 3.57 21.15C3.63 22.48 3.84 23.39 4.15 24.18C4.47 25 4.9 25.7 5.59 26.4C6.29 27.09 6.98 27.52 7.81 27.84C8.6 28.15 9.51 28.36 10.84 28.42C12.17 28.48 12.6 28.5 15.99 28.5C19.39 28.5 19.81 28.48 21.15 28.42C22.48 28.36 23.39 28.15 24.18 27.84C25.01 27.52 25.7 27.09 26.4 26.4C27.09 25.7 27.52 25 27.84 24.18C28.15 23.39 28.36 22.48 28.42 21.15C28.48 19.81 28.5 19.39 28.5 16C28.5 12.6 28.48 12.17 28.42 10.84C28.36 9.51 28.15 8.6 27.84 7.81C27.52 6.98 27.09 6.29 26.4 5.59C25.7 4.9 25.01 4.47 24.18 4.15C23.39 3.84 22.48 3.63 21.15 3.57C19.81 3.51 19.39 3.5 15.99 3.5L16 3.5ZM14.87 5.75C15.21 5.75 15.58 5.75 16 5.75C19.33 5.75 19.73 5.76 21.05 5.82C22.27 5.88 22.93 6.08 23.37 6.25C23.95 6.48 24.37 6.75 24.8 7.18C25.24 7.62 25.51 8.04 25.74 8.62C25.91 9.06 26.12 9.72 26.17 10.94C26.23 12.26 26.24 12.66 26.24 15.99C26.24 19.33 26.23 19.72 26.17 21.04C26.11 22.26 25.91 22.92 25.74 23.36C25.51 23.95 25.24 24.36 24.8 24.8C24.37 25.24 23.95 25.51 23.37 25.73C22.93 25.9 22.27 26.11 21.05 26.16C19.73 26.22 19.33 26.24 16 26.24C12.66 26.24 12.26 26.22 10.95 26.16C9.73 26.11 9.06 25.9 8.62 25.73C8.04 25.51 7.62 25.24 7.19 24.8C6.75 24.36 6.48 23.94 6.25 23.36C6.08 22.92 5.88 22.26 5.82 21.04C5.76 19.72 5.75 19.33 5.75 15.99C5.75 12.65 5.76 12.26 5.82 10.94C5.88 9.72 6.08 9.06 6.25 8.62C6.48 8.04 6.75 7.62 7.19 7.18C7.62 6.74 8.04 6.47 8.62 6.25C9.06 6.07 9.73 5.87 10.95 5.81C12.1 5.76 12.55 5.75 14.87 5.74L14.87 5.75ZM22.67 7.82C21.84 7.82 21.17 8.49 21.17 9.32C21.17 10.15 21.84 10.82 22.67 10.82C23.5 10.82 24.17 10.15 24.17 9.32C24.17 8.49 23.5 7.82 22.67 7.82L22.67 7.82ZM16 9.58C12.45 9.58 9.58 12.45 9.58 16C9.58 19.54 12.45 22.41 16 22.41C19.54 22.41 22.41 19.54 22.41 16C22.41 12.45 19.54 9.58 16 9.58L16 9.58ZM16 11.83C18.3 11.83 20.16 13.69 20.16 16C20.16 18.3 18.3 20.16 16 20.16C13.7 20.16 11.83 18.3 11.83 16C11.83 13.69 13.7 11.83 16 11.83Z",
    fill: "#FFFFFF",
    fillOpacity: 1,
    fillRule: "nonzero"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagramIcon);
export default __webpack_public_path__ + "static/media/instagram-icon.dac29f0b7859805a37c6f386ba1828c8.svg";
export { ForwardRef as ReactComponent };